export const RecordTaskInspectionResultFragment = gql`
  fragment RecordTaskInspectionResultFragment on RecordTaskInspectionResult {
    id
    isPassing
    name
  }
`
